import React, { useState, Children, memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, Eye, Sun, BookOpen, Brain, HeartPulse, Magnet, ChevronDown } from 'lucide-react';
const services = [{
  id: 'tarot',
  title: 'Tarot',
  description: 'Recibe claridad y guía a través de las cartas para comprender tu momento actual. Una lectura profunda para iluminar tu camino.',
  benefits: ['Claridad sobre tu situación actual', 'Orientación para tomar decisiones', 'Conexión con tu intuición', 'Comprensión de patrones repetitivos'],
  icon: Eye,
  whatsappUrl: 'https://wa.me/34690752576?text=Hola%20Vanii%20%F0%9F%98%8A%20Soy%20%5Btu%20nombre%5D%20y%20me%20gustar%C3%ADa%20recibir%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20sesi%C3%B3n%20de%20Tarot%20%F0%9F%94%AE'
}, {
  id: 'mediumnidad',
  title: 'Mediumnidad',
  description: 'Conexión directa con seres de luz y mensajes del otro plano para tu sanación. Un puente de amor entre dimensiones.',
  benefits: ['Mensajes de seres queridos fallecidos', 'Guía espiritual personalizada', 'Sanación emocional profunda', 'Paz y cierre con el pasado'],
  icon: Sparkles,
  whatsappUrl: 'https://wa.me/34690752576?text=Hola%20Vanii%20%F0%9F%98%8A%20Soy%20%5Btu%20nombre%5D%20y%20me%20gustar%C3%ADa%20recibir%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20sesi%C3%B3n%20de%20Mediuminidad%20%E2%9C%A8'
}, {
  id: 'alineamiento',
  title: 'Alineamiento Energético',
  description: 'Limpieza y armonización de tu campo energético con magia blanca para recuperar tu equilibrio y vitalidad natural.',
  benefits: ['Eliminación de bloqueos energéticos', 'Restauración del equilibrio interior', 'Mayor vitalidad y bienestar', 'Protección energética duradera'],
  icon: Sun,
  whatsappUrl: 'https://wa.me/34690752576?text=Hola%20Vanii%20%F0%9F%98%8A%20Soy%20%5Btu%20nombre%5D%20y%20me%20gustar%C3%ADa%20recibir%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20Alineamiento%20Energ%C3%A9tico%20%F0%9F%8C%BF'
}, {
  id: 'biomagnetismo',
  title: 'Biomagnetismo',
  description: 'Terapia con imanes para equilibrar el pH del cuerpo, eliminando virus, bacterias y restaurando la salud física y energética.',
  benefits: ['Equilibrio del pH corporal', 'Fortalecimiento del sistema inmune', 'Alivio de dolencias físicas', 'Armonización cuerpo-mente'],
  icon: Magnet,
  whatsappUrl: 'https://wa.me/34690752576?text=Hola%20Vanii%20%F0%9F%98%8A%20Soy%20%5Btu%20nombre%5D%20y%20me%20gustar%C3%ADa%20recibir%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Biomagnetismo%20%F0%9F%A7%B2'
}, {
  id: 'transpersonal',
  title: 'Terapia Transpersonal',
  description: 'Exploración profunda de tu ser para comprender patrones, liberar bloqueos y conectar con tu verdadera esencia.',
  benefits: ['Comprensión de patrones inconscientes', 'Liberación de traumas y bloqueos', 'Conexión con tu esencia auténtica', 'Herramientas de autoconocimiento', 'Crecimiento personal profundo'],
  icon: Brain,
  whatsappUrl: 'https://wa.me/34690752576?text=Hola%20Vanii%20%F0%9F%98%8A%20Soy%20%5Btu%20nombre%5D%20y%20me%20gustar%C3%ADa%20recibir%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Terapia%20Transpersonal%20%F0%9F%A7%A0'
}, {
  id: 'bioneuroemocion',
  title: 'Terapia de Bioneuroemoción',
  description: 'Descubre el origen emocional de tus conflictos físicos o de vida y transforma tu realidad desde la toma de conciencia.',
  benefits: ['Identificación del origen emocional', 'Resolución de conflictos internos', 'Transformación de creencias limitantes', 'Mayor conciencia de ti misma'],
  icon: HeartPulse,
  whatsappUrl: 'https://wa.me/34690752576?text=Hola%20Vanii%20%F0%9F%98%8A%20Soy%20%5Btu%20nombre%5D%20y%20me%20gustar%C3%ADa%20recibir%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Terapia%20de%20Bioneuroemoción%20%F0%9F%92%AB'
}, {
  id: 'registros',
  title: 'Formación: Registros Akáshicos',
  description: 'Aprende a acceder a la memoria del alma. Formación completa dividida en niveles para tu desarrollo espiritual.',
  benefits: ['Acceso a la memoria de tu alma', 'Formación por niveles progresivos', 'Desarrollo de tu canal intuitivo', 'Certificación al completar'],
  icon: BookOpen,
  whatsappUrl: 'https://wa.me/34690752576?text=Hola%20Vanii%20%F0%9F%98%8A%20Soy%20%5Btu%20nombre%5D%20y%20me%20gustar%C3%ADa%20recibir%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Registros%20Ak%C3%A1shicos%20%F0%9F%94%AE'
}, {
  id: 'hipnosis',
  title: 'Hipnosis Sanadora',
  quote: 'Tú decides qué hacer con las piedras que te encuentras en el camino.',
  description: 'Con la hipnosis sanadora, te acompaño a liberar bloqueos emocionales y mentales desde un estado de relajación profunda, manteniéndote consciente en todo momento.',
  benefits: ['Soltar emociones atrapadas', 'Comprender el origen de lo que te bloquea', 'Sanar heridas internas', 'Recuperar paz mental y claridad', 'Avanzar con más ligereza en tu vida'],
  closingText: 'Es un proceso suave, seguro y transformador donde tú tienes el control en todo momento.',
  icon: Sparkles,
  whatsappUrl: 'https://wa.me/34690752576?text=Hola%20Vanii%20%F0%9F%98%8A%20Soy%20%5Btu%20nombre%5D%20y%20me%20gustar%C3%ADa%20recibir%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Hipnosis%20Sanadora%20%F0%9F%8C%99'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function Services() {
  const [expandedId, setExpandedId] = useState<string | null>(null);
  function toggleExpand(id: string) {
    setExpandedId(prev => prev === id ? null : id);
  }
  return <section id="servicios" className="py-24 relative overflow-hidden" data-id="element-262">
      {/* Soft background image */}
      <div className="absolute inset-0 z-0" data-id="element-263">
        <img src="https://cdn.magicpatterns.com/uploads/fbQ74FsC3s2dT3V3tvS8GU/2.png" alt="" className="w-full h-full object-cover object-left" aria-hidden="true" data-id="element-264" />
        <div className="absolute inset-0 bg-white/[0.62]" data-id="element-265" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-266">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-267">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-serif text-stone-900 mb-4" data-id="element-268">
            Servicios
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg text-stone-600 font-light" data-id="element-269">
            Elige el camino que resuene contigo
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-270">
          {services.map(service => {
          const isExpanded = expandedId === service.id;
          return <motion.div key={service.id} variants={itemVariants} layout className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-sm border border-stone-100/60 flex flex-col overflow-hidden" data-id="element-271">
                {/* Clickable header area */}
                <button onClick={() => toggleExpand(service.id)} className="w-full text-left p-8 pb-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-300 focus-visible:ring-inset rounded-t-2xl" aria-expanded={isExpanded} data-id="element-272">
                  <div className="flex items-start justify-between gap-3" data-id="element-273">
                    <div className="w-12 h-12 bg-violet-50 rounded-xl flex items-center justify-center text-violet-600 shrink-0" data-id="element-274">
                      <service.icon size={24} strokeWidth={1.5} data-id="element-275" />
                    </div>
                    <div className="flex items-center gap-1.5 mt-1" data-id="element-276">
                      <span className="text-xs font-medium text-violet-400/70" data-id="element-277">
                        {isExpanded ? 'Ocultar' : 'Ver detalles'}
                      </span>
                      <motion.div animate={{
                    rotate: isExpanded ? 180 : 0
                  }} transition={{
                    duration: 0.3
                  }} className="text-violet-400/70" data-id="element-278">
                        <ChevronDown size={16} data-id="element-279" />
                      </motion.div>
                    </div>
                  </div>

                  <h3 className="text-xl font-serif font-semibold text-stone-900 mt-4" data-id="element-280">
                    {service.title}
                  </h3>
                </button>

                {/* Expandable content */}
                <AnimatePresence initial={false} data-id="element-281">
                  {isExpanded && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.35,
                ease: [0.4, 0, 0.2, 1]
              }} className="overflow-hidden" data-id="element-282">
                      <div className="px-8 pb-2 space-y-4" data-id="element-283">
                        {service.quote && <p className="text-violet-600 font-serif italic text-sm leading-relaxed" data-id="element-284">
                            "{service.quote}"
                          </p>}

                        <p className="text-stone-600 font-light leading-relaxed text-sm" data-id="element-285">
                          {service.description}
                        </p>

                        <ul className="space-y-2.5" data-id="element-286">
                          {service.benefits.map((benefit, i) => <li key={i} className="flex items-start gap-2.5 text-sm text-stone-700" data-id="element-287">
                              <div className="w-1.5 h-1.5 rounded-full bg-amber-400 mt-1.5 shrink-0" data-id="element-288" />
                              <span data-id="element-289">{benefit}</span>
                            </li>)}
                        </ul>

                        {service.closingText && <p className="text-stone-500 font-light text-xs leading-relaxed italic pt-1" data-id="element-290">
                            {service.closingText}
                          </p>}
                      </div>
                    </motion.div>}
                </AnimatePresence>

                {/* CTA — always visible */}
                <div className="mt-auto px-8 pb-8 pt-5 border-t border-stone-100 space-y-3" data-id="element-291">
                  <a href={service.whatsappUrl} target="_blank" rel="noopener noreferrer" className="block w-full text-center py-2.5 px-6 rounded-full bg-violet-600 text-white font-medium hover:bg-violet-700 transition-colors duration-300 text-sm" data-id="element-292">
                    Consultar por WhatsApp
                  </a>
                  <button onClick={() => toggleExpand(service.id)} className="block w-full text-center py-2 px-6 text-violet-500 font-medium text-xs hover:text-violet-700 transition-colors duration-300" data-id="element-293">
                    {isExpanded ? 'Ocultar detalles' : 'Ver detalles'}
                  </button>
                </div>
              </motion.div>;
        })}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="mt-14 text-center max-w-xl mx-auto" data-id="element-294">
          <p className="text-stone-500 font-light text-base leading-relaxed mb-4" data-id="element-295">
            ¿No sabes qué servicio es el más adecuado para ti? No te preocupes,
            escríbeme y te oriento sin compromiso.
          </p>
          <a href="https://wa.me/34690752576?text=Hola%2C%20tengo%20dudas%20sobre%20qu%C3%A9%20sesi%C3%B3n%20elegir%20y%20me%20gustar%C3%ADa%20que%20me%20orientaras%20%F0%9F%99%8F" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-violet-600 font-medium text-sm hover:text-violet-700 transition-colors" data-id="element-296">
            Pregúntame por WhatsApp →
          </a>
        </motion.div>
      </div>
    </section>;
}